import { BookService } from 'api/book/service';
import { useCallback } from 'react';


export const useBook = () => {
    const onGetAllBooks = useCallback(async () => {
        try {
            const response = await BookService.getInstance().findAll();
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, data: null };
        }
    }, []); // Зависимости не нужны, так как нет внешних переменных

    const onGetOneBook = useCallback(async (id: number) => {
        try {
            const response = await BookService.getInstance().findOne(id);
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, data: null };
        }
    }, []); // Зависимости не нужны, так как нет внешних переменных

    return { onGetAllBooks, onGetOneBook };
};
